export default __webpack_public_path__ + "static/media/live-casino-cat.6f606674.webp";